// extracted by mini-css-extract-plugin
export default {"userChip":"useColumns_userChip__vkJFO","teams":"useColumns_teams__uLyFN","teamChip":"useColumns_teamChip__pdoNW"};